<template>
    <div id="body">
      <main-navigation></main-navigation>

      <base-card>
        <div id="element-to-convert">
          <div class="row">
            <div class="col-lg-3">
              <img width="300" height="150" src="../../assets/ng-cdflogo.jpg" />
            </div>

            <div class="col-lg-9">
              National Government Constituencies Development Fund
              <br />
              North Mugirango constituency,
              <br />
              P.O BOX 105-40500, Nyamira
              <br />
              Email: cdfnorthmugirango@cdf.go.ke || cell: 0721431120
            </div>
          </div>

          <div class="row">
            <div class="col-lg-9">
              <small>Your Ref: BURSARY 2025/26-NORTH MUGIRANGO </small>
            </div>
            <div class="col-lg-3">Date <strong> ...................................... </strong></div>
          </div>

          <small>
<p class="text-primary">To: {{ schoolName }}</p>

            Dear sir/Madam

            <p class="font-italic">
              RE: BURSARY AWARD OF <strong>KSHS {{ total_awarded }}</strong>,
              CHEQUE NUMBER .......................................,
              DATED <strong>........................................</strong>
            </p>

            Kindly receive and acknowledge the above bursary cheque in respect to
            the following
            <strong>{{ MynewsecApproved.length }} student(s)</strong>.
          </small>

          <table class="table myFormat table-striped table-bordered table-sm">
            <thead>
              <tr>
                <th><small>No.</small></th>
                <th><small>Name</small></th>
                <th><small>Adm No.</small></th>
                <th><small>Class</small></th>
                <th><small>Ward</small></th>
                <th><small>Amount</small></th>
              </tr>
            </thead>

            <tbody>
              <tr
                style="height:2px;"
                v-for="(student, index) in MynewsecApproved"
                :key="student.id"
              >
                <td style="padding:0px;">
                  <small>{{ index + 1 }}</small>
                </td>

                <td style="padding:0px;">
                  <small>{{ student.studentName }}</small>
                </td>

                <td style="padding:0px;">
                  <small>{{ student.adminNumber }}</small>
                </td>

                <td style="padding:0px;">
                  <small>{{ student.student_form }}</small>
                </td>

                <td style="padding:0px;">
                  <small>{{ student.ward }}</small>
                </td>

                <td style="padding:0px;">
                  <small>{{ student.amount_awarded }}</small>
                </td>
              </tr>
            </tbody>
          </table>

          <br />

          <small>
            Any uncredited amount should be reported in writing and returned to the
            North Mugirango Constituency development office
            <br />
            Yours Faithfully
            <br /><br />

            <div class="row">
              <div class="col-lg-6">Robert Serem, Fund account Manager</div>
              <div class="col-lg-6">
                Stamp and signature:
                .................................................
              </div>
            </div>
          </small>
        </div>

        <br />
        <button @click="exportToPDF">Download Letter</button>
        <br />
        <router-link to="/">Go back</router-link>
      </base-card>
    </div>
</template>

<script>
import axios from "axios";
import html2pdf from "html2pdf.js";

export default {
//   data() {
//     return {
//       approvedStudents: [],
//     };
//   },

data() {
  return {
    students: [],
    schools: [],
    schoolName: "Bursary Letter"
  };
},

  

//   computed: {
//     school() {
//       return this.$route.params.school;
//     },

// MynewsecApproved() {
//   return this.approvedStudents
//     .filter(s =>
//       String(s.school_code).trim() === String(this.school).trim() &&
//       Number(s.processed) === 1
//     )
//     .sort((a, b) => a.studentName.localeCompare(b.studentName));
// },


//   school_names(){
//          return this.$store.getters.specificSecondaryName(this.$route.params.school )
 
//        },

//     total_awarded() {
//       return this.MynewsecApproved.reduce(
//         (sum, s) => sum + Number(s.amount_awarded || 0),
//         0
//       );
//     },
//   },

computed: {
  MynewsecApproved() {
    return this.students
      .filter(
        s =>
          s.processed == 1 &&
          String(s.school_code) === String(this.$route.params.school)
      )
      .sort((a, b) => a.studentName.localeCompare(b.studentName));
  },

  total_awarded() {
    return this.MynewsecApproved.reduce(
      (sum, s) => sum + parseInt(s.amount_awarded || 0, 10),
      0
    );
  }
},


  methods: {
    async fetchApprovedStudents() {
      try {
        const res = await axios.get(
          "https://api.roberms.com/nyamoko/get/secondary/approved"
        );

        this.approvedStudents = Array.isArray(res.data)
          ? res.data
          : res.data.data || [];
      } catch (err) {
        console.error("Failed to load approved students", err);
      }
    },

    exportToPDF() {
  const element = document.getElementById("element-to-convert");
  const safeName = this.schoolName

  html2pdf()
    .set({
      margin: [10, 10, 10, 10],
    filename: `${safeName} 2026.pdf`,

    //   filename: f?ileName,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 3,
        dpi: 300,
        useCORS: true,
        letterRendering: true
      },
      jsPDF: {
        unit: "mm",
        format: "a4",
        orientation: "portrait"
      },
      pagebreak: {
        mode: ["css", "legacy"] // 👈 THIS IS KEY
      }
    })
  .from(element)
    .save();
    
}

  },

created() {
  // 1. Load approved students
  axios
    .get("https://api.roberms.com/nyamoko/get/college/approved")
    .then(res => {
      this.students = res.data;
    });

  // 2. Load school names
  axios
    .get("https://api.roberms.com/nyamoko/get/college/names")
    .then(res => {
      this.schools = res.data;

      const match = this.schools.find(
        s => String(s.the_code) === String(this.$route.params.school)
      );

      if (match) {
        this.schoolName = match.school_name;
      }
    });
}

};
</script>

<style scoped>
/* Prevent table rows from breaking across pages */
table {
  page-break-inside: auto;
}

tr {
  page-break-inside: avoid !important;
  page-break-after: auto;
}

td, th {
  page-break-inside: avoid !important;
  white-space: nowrap; /* prevents name wrapping weirdly */
}

/* Allow wrapping only if needed, but still keep row intact */
td small {
  white-space: normal;
}

</style>
